import * as React from "react"
export const Svg_060 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="m29.5 33.534 5.245-1.933v-5.554h-10.49v5.554l5.245 1.933Z"
    />
    <path
      fill="url(#b)"
      d="M0 6.462v46.076h59V6.462H0Zm53.006 35.68-4.633 4.632H10.627l-4.633-4.632V16.858l4.633-4.632h37.746l4.633 4.632v25.284Z"
    />
    <path
      fill="url(#c)"
      d="M12.059 15.683 9.452 18.29v22.42l2.607 2.606H46.94l2.607-2.606V18.29l-2.607-2.606H12.06Zm32.886 18.379h-3.458v-8.015h-3.285v7.964L29.5 37.22l-8.702-3.209v-7.964h-6.743v-3.458h30.89v11.473Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={26.681}
        x2={29.618}
        y1={27.17}
        y2={33.828}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={13.644}
        x2={32.8}
        y1={13.373}
        y2={53.074}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={18.724}
        x2={29.305}
        y1={19.828}
        y2={44.676}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)